import { setCurrentConversation } from "../currentConversation/setCurrentConversation";
import { fetchConversations } from "./fetchConversations";

export const CREATE_CONVERSATION_BEGIN = "CREATE_CONVERSATION_BEGIN";
export const CREATE_CONVERSATION_SUCCESS = "CREATE_CONVERSATION_SUCCESS";
export const CREATE_CONVERSATION_FAILED = "CREATE_CONVERSATION_FAILED";

const createConversationBeginAction = (payload) => ({
  type: CREATE_CONVERSATION_BEGIN,
  payload,
});
const createConversationSuccessAction = (payload) => ({
  type: CREATE_CONVERSATION_SUCCESS,
  payload,
});
const createConversationBeginFailed = (payload) => ({
  type: CREATE_CONVERSATION_FAILED,
  payload,
});

export const createConversation = (
  recipients,
  body,
  readOnly,
  conversationTitle,
  kind,
  selectedCategory,
  selectedCategoryGroupId
) => {
  return (dispatch, getState) => {
    const { organization } = getState();
    dispatch(createConversationBeginAction());
    return $.ajax({
      url: `/api/staff/v1/conversations.json`,
      method: "POST",
      data: {
        conversation: {
          recipients: kind.value == "recipient" ? recipients : [],
          category: kind.value == "category" ? selectedCategory : null,
          category_group_id:
            kind.value == "category" ? selectedCategoryGroupId : null,
          kind: kind.value,
          body,
          subject: !!conversationTitle ? conversationTitle : "Conversation",
          is_read_only: readOnly || kind.value == "category",
        },
      },
    }).then((response) => {
      dispatch(createConversationSuccessAction(response));
      dispatch(fetchConversations(true, false)).then(() =>
        dispatch(setCurrentConversation(response))
      );
    });
  };
};
